import script from "./GstHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GstHeader.vue?vue&type=script&setup=true&lang=js"

import "./GstHeader.vue?vue&type=style&index=0&id=56f978d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f978d8"]])

export default __exports__